import { Controller } from '@hotwired/stimulus';

// A fixed corner button never sits on a field (docs/DESIGN.md § chat / fab /
// timeline): jane's help bubble, the smart btn (the element itself). At every width it fades out, and
// stops taking taps, while a visible field or a button she presses is under it:
// `data-covers`, which fire.css draws. It looks again on every scroll, resize, layout change, focus move and morph;
// one held open (focus inside) stays. A field in a popover is its own card's; a modal's backdrop
// button, and anything not visible, is never one.
// A field is the box she sees (BOX), not the bare input inside it.
const FIELDS = 'input:not([type=hidden]):not([type=submit]):not([type=checkbox]):not([type=radio]), select, textarea';
const PRESS = 'button, [type=submit], a.btn, [data-fab-off]';
const BOX = '.input, .select, .textarea';

export default class extends Controller {
  connect() {
    this.look = () => (this.frame ||= requestAnimationFrame(() => this.check()));
    this.ro = new ResizeObserver(this.look);
    this.ro.observe(document.body);
    addEventListener('scroll', this.look, { passive: true });
    addEventListener('resize', this.look);
    addEventListener('turbo:morph', this.look);
    this.element.addEventListener('focusin', this.look);
    this.element.addEventListener('focusout', this.look);
    this.look();
  }

  disconnect() {
    this.ro.disconnect();
    removeEventListener('scroll', this.look);
    removeEventListener('resize', this.look);
    removeEventListener('turbo:morph', this.look);
    this.element.removeEventListener('focusin', this.look);
    this.element.removeEventListener('focusout', this.look);
    cancelAnimationFrame(this.frame);
  }

  check() {
    this.frame = null;
    const a = this.element.getBoundingClientRect();
    const under =
      !this.element.matches(':focus-within') &&
      [...document.querySelectorAll(`${FIELDS}, ${PRESS}`)].some((field) => {
        const b = (field.closest(BOX) ?? field).getBoundingClientRect();
        return (
          b.width > 0 &&
          !this.element.contains(field) &&
          !field.closest('[popover], .modal-backdrop') &&
          // ponytail: Safari < 17.4 has no checkVisibility; getClientRects only sees display:none, so a
          // visibility:hidden button there still counts as under the bubble, which just fades it.
          (field.checkVisibility?.({ visibilityProperty: true }) ?? field.getClientRects().length > 0) &&
          a.left < b.right &&
          a.right > b.left &&
          a.top < b.bottom &&
          a.bottom > b.top
        );
      });
    this.element.toggleAttribute('data-covers', under);
  }
}
